import type { AiModelUpdateFailedAction } from '@Application/Ai/AiConfiguration/Models/Actions/aiModelUpdateFailed';
import type { FieldError } from '@Infra/FetchLib/ApiError';

const FORM_FIELD_BY_SERVER_FIELD: Readonly<Record<string, string>> = Object.freeze({
	'azureSpeechSettings.locale': 'speechLocale',
	'azureSpeechSettings.maxSpeakers': 'speechMaxSpeakers',
	'azureSpeechSettings.profanityFilter': 'speechProfanityFilter',
	'azureSpeechSettings.phrases': 'speechPhrases',
	'azureSpeechSettings.phraseWeight': 'speechPhraseWeight',
});

const PHRASE_ITEM_PREFIX = 'azureSpeechSettings.phrases.';

const mapField = (field: string): string => {
	if (field.startsWith(PHRASE_ITEM_PREFIX)) {
		return 'speechPhrases';
	}

	return FORM_FIELD_BY_SERVER_FIELD[field] ?? field;
};

/** Rewrites the nested server field names to the flat form fields; returns a new action. */
const mapAzureSpeechFieldErrors = (action: AiModelUpdateFailedAction): AiModelUpdateFailedAction => {
	if (action.payload === undefined) {
		return action;
	}

	const fieldErrors: FieldError[] = action.payload.fieldErrors.map((fieldError) => ({
		...fieldError,
		field: mapField(fieldError.field),
	}));

	return { ...action, payload: { ...action.payload, fieldErrors } };
};

export default mapAzureSpeechFieldErrors;
